<div class="pointer" (click)="isOpenMenu= true" #trigger>
    <img src="\assets\images\data\menu-side.svg">
</div>
<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayHasBackdrop]="true" (backdropClick)="isOpenMenu=false"
    [cdkConnectedOverlayOpen]="isOpenMenu"
    cdkConnectedOverlayBackdropClass="backdrop-selection"
    [cdkConnectedOverlayPositions]="positonAreaForSelectedDate">

    <div class="overlay-warp">
        <div class="item" (click)="changeStatus()" translate>data.changeStatus</div>
    </div>
</ng-template>